var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignature(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_593_8595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6481 7.92712L10.9908 6.26982M6.84766 12.0703C6.84766 11.0092 7.26918 9.99149 8.01953 9.24114L12.4138 4.8469C12.8714 4.38926 13.6134 4.38926 14.0711 4.8469C14.5287 5.30455 14.5287 6.04655 14.0711 6.50417L9.6768 10.8984C9.30527 11.27 8.8642 11.5647 8.37878 11.7658C7.89335 11.9668 7.37308 12.0703 6.84766 12.0703Z",
    stroke: "#747474",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1328 12.7481V13.2422C11.1328 13.8894 10.6081 14.4141 9.96094 14.4141H1.75781C1.11062 14.4141 0.585938 13.8894 0.585938 13.2422V1.75781C0.585938 1.11062 1.11062 0.585938 1.75781 0.585938H8.30364C8.45754 0.585933 8.60992 0.616243 8.7521 0.675137C8.89428 0.734031 9.02346 0.820355 9.13228 0.92918L10.7896 2.58645C10.9311 2.72795 11.034 2.90336 11.0885 3.09595",
    stroke: "#747474",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.92969 12.0703C2.92969 11.4231 3.45437 10.8984 4.10156 10.8984C4.74876 10.8984 5.27344 11.4231 5.27344 12.0703H6.84744M2.92969 4.10156H6.44531M2.92969 6.44531H6.44531",
    stroke: "#747474",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_593_8595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignature);
export default __webpack_public_path__ + "static/media/Signature.9eaf0b6af7a9b28b186b60daf7ba2dce.svg";
export { ForwardRef as ReactComponent };